import { memo } from 'react';
import { cn } from '@divlab/divanui';

import styles from './IconLike.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface LikeProps extends HTMLAttributes<SVGSVGElement> {
  className?: string;
  liked?: boolean;
}

const Like: FC<LikeProps> = (props) => {
  const { className, liked, ...restProps } = props;

  return (
    <svg
      className={cn(styles.like, { [styles.liked]: liked }, className)}
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M10.8227 7.4668C7.12458 7.4668 4.80005 10.8758 4.80005 13.6249C4.80005 19.673 11.351 24.2146 16 27.7335C20.6491 24.2146 27.2 19.673 27.2 13.6249C27.2 10.8758 24.8755 7.4668 21.1774 7.4668C19.0642 7.4668 17.268 9.22629 16 10.8758C14.6265 9.22629 12.9359 7.4668 10.8227 7.4668Z'
        strokeWidth='1.5'
        strokeMiterlimit='10'
      />
    </svg>
  );
};

export default memo(Like);
